import React from "react";
import { Bubble } from "react-chartjs-2";

const ChartBubleLainSekolah = (dataPerforma) => {
    let listData = dataPerforma.data
    const options = {
        responsive: true,
    };

    function getDataChart(x, y) {
        let result = []
        const newData = new Object()
        newData.x = x
        newData.y = y
        newData.r = 5
        result.push(newData)
        return result;
    }
    function getDataset() {
        let dataSet = []
        for (let i in listData) {
            const data = listData[i]
            const newdataSet = new Object()
            newdataSet.label = data.namaMataPelajaran
            newdataSet.data = getDataChart(data.x, data.y)
            newdataSet.backgroundColor = data.namaMataPelajaran == 'MEMBACA' ? '#03C46B' : data.namaMataPelajaran == 'MATEMATIKA' ? '#FEBC04' : '#FF3838'
            newdataSet.hoverBackgroundColor = '#FFFFFF'
            newdataSet.hoverBorderColor = data.namaMataPelajaran == 'MEMBACA' ? '#03C46B' : data.namaMataPelajaran == 'MATEMATIKA' ? '#FEBC04' : '#FF3838'
            newdataSet.hoverBorderWidth = 5
            newdataSet.hoverRadius = 5
            dataSet.push(newdataSet)
        }
        return dataSet;
    }
    const data = {
        datasets: getDataset()
    };

    return (
        <div style={{ width: '100%' }}>
            <Bubble data={data} options={options} width={500} height={500} />
        </div>
    );
};

export default ChartBubleLainSekolah;
